module.exports = __webpack_public_path__ + "static/media/banner-insc.0c36bdec.png";